var _defs, _path, _path2, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateBlankMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    zoomAndPan: "magnify",
    viewBox: "0 0 97.5 97.499997",
    height: 130,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5dc8a3e685"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37 17.160156 L 60 17.160156 L 60 40 L 37 40 Z M 37 17.160156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "365e4b9cad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37 57 L 60 57 L 60 79.839844 L 37 79.839844 Z M 37 57 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9b534c66f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.328125 57 L 32 57 L 32 79.839844 L 9.328125 79.839844 Z M 9.328125 57 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "67fac75cd0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 65 57 L 87.675781 57 L 87.675781 79.839844 L 65 79.839844 Z M 65 57 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 48.5 60.949219 C 47.636719 60.949219 46.933594 60.25 46.933594 59.382812 L 46.933594 37.648438 C 46.933594 36.78125 47.636719 36.082031 48.5 36.082031 C 49.367188 36.082031 50.070312 36.78125 50.070312 37.648438 L 50.070312 59.382812 C 50.070312 60.25 49.367188 60.949219 48.5 60.949219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 76.65625 60.949219 C 75.792969 60.949219 75.089844 60.25 75.089844 59.382812 L 75.089844 50.082031 L 21.914062 50.082031 L 21.914062 59.382812 C 21.914062 60.25 21.210938 60.949219 20.34375 60.949219 C 19.480469 60.949219 18.777344 60.25 18.777344 59.382812 L 18.777344 48.515625 C 18.777344 47.648438 19.480469 46.949219 20.34375 46.949219 L 76.65625 46.949219 C 77.523438 46.949219 78.222656 47.648438 78.222656 48.515625 L 78.222656 59.382812 C 78.222656 60.25 77.523438 60.949219 76.65625 60.949219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5dc8a3e685)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 48.5 20.308594 C 44.152344 20.308594 40.617188 23.847656 40.617188 28.195312 C 40.617188 32.542969 44.152344 36.082031 48.5 36.082031 C 52.851562 36.082031 56.386719 32.542969 56.386719 28.195312 C 56.386719 23.847656 52.851562 20.308594 48.5 20.308594 Z M 48.5 39.214844 C 42.425781 39.214844 37.480469 34.273438 37.480469 28.195312 C 37.480469 22.117188 42.425781 17.175781 48.5 17.175781 C 54.578125 17.175781 59.519531 22.117188 59.519531 28.195312 C 59.519531 34.273438 54.578125 39.214844 48.5 39.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#365e4b9cad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 48.5 60.949219 C 44.152344 60.949219 40.617188 64.488281 40.617188 68.835938 C 40.617188 73.183594 44.152344 76.722656 48.5 76.722656 C 52.851562 76.722656 56.386719 73.183594 56.386719 68.835938 C 56.386719 64.488281 52.851562 60.949219 48.5 60.949219 Z M 48.5 79.855469 C 42.425781 79.855469 37.480469 74.914062 37.480469 68.835938 C 37.480469 62.761719 42.425781 57.816406 48.5 57.816406 C 54.578125 57.816406 59.519531 62.761719 59.519531 68.835938 C 59.519531 74.914062 54.578125 79.855469 48.5 79.855469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9b534c66f2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 20.34375 60.949219 C 15.996094 60.949219 12.460938 64.488281 12.460938 68.835938 C 12.460938 73.183594 15.996094 76.722656 20.34375 76.722656 C 24.695312 76.722656 28.230469 73.183594 28.230469 68.835938 C 28.230469 64.488281 24.695312 60.949219 20.34375 60.949219 Z M 20.34375 79.855469 C 14.269531 79.855469 9.324219 74.914062 9.324219 68.835938 C 9.324219 62.761719 14.269531 57.816406 20.34375 57.816406 C 26.421875 57.816406 31.363281 62.761719 31.363281 68.835938 C 31.363281 74.914062 26.421875 79.855469 20.34375 79.855469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#67fac75cd0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 76.65625 60.949219 C 72.308594 60.949219 68.773438 64.488281 68.773438 68.835938 C 68.773438 73.183594 72.308594 76.722656 76.65625 76.722656 C 81.003906 76.722656 84.542969 73.183594 84.542969 68.835938 C 84.542969 64.488281 81.003906 60.949219 76.65625 60.949219 Z M 76.65625 79.855469 C 70.582031 79.855469 65.640625 74.914062 65.640625 68.835938 C 65.640625 62.761719 70.582031 57.816406 76.65625 57.816406 C 82.734375 57.816406 87.675781 62.761719 87.675781 68.835938 C 87.675781 74.914062 82.734375 79.855469 76.65625 79.855469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateBlankMapIcon);
export default __webpack_public_path__ + "static/media/create_blank_map_icon.4b112d86a929aedda08c17719e87fdb1.svg";
export { ForwardRef as ReactComponent };